import { type Common } from '../common.js';
import {
  type FindAllOptions,
  type PhoneNumberConfigurationFindDefaultOptions,
  type PhoneNumberConfigurationFindDefaultResponse,
  type PhoneNumberConfigurationWithDirection,
  type UpdateDetailsValues,
} from '../models/assistant/phoneNumberConfiguration.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/phone-number-configurations';
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PhoneNumberConfigurationWithDirection>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAll(options: FindAllOptions): Promise<PhoneNumberConfigurationWithDirection[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PhoneNumberConfigurationWithDirection> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async update(
    id: string,
    values: UpdateDetailsValues
  ): Promise<PhoneNumberConfigurationWithDirection> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/details`);
    return await this.common.patchJSON(url, values);
  }

  async findDefault(
    options: PhoneNumberConfigurationFindDefaultOptions
  ): Promise<PhoneNumberConfigurationFindDefaultResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/default`, {
      organizationId: options.organizationId,
    });
    return await this.common.getJSON(url);
  }
}
